<template>
  <div>
    <dial-assign-driver
      ref="dialassignitem"
      :mode="mode"
      :selectedItem="selectedItem"
      :template="template"
      :to-edit="toEdit"
      @avalaible="avalaible = $event"
      @done="reload = true"
      @updateAssignItems="getAssignItems"
      v-model="dialog"
    />
    <div>
      <!-- Botón agregar -->
      <v-chip
        v-if="!qtyAssignItems"
        class="mr-2"
        color="success"
        @click.stop="open()"
      >
        <v-icon class="mr-1" small>fas fa-plus</v-icon>
        {{ $t('assign_people', { value: getTranslateMode(mode) }) }}
      </v-chip>

      <!-- Botón editar -->
      <v-chip v-else class="mr-2" color="primary" @click.stop="open()">
        <v-icon class="mr-1" small>fas fa-pencil</v-icon>
        {{ getTranslateMode(mode) }} ({{ qtyAssignItems }})
      </v-chip>

      <!-- Items asignados -->
      <div v-if="qtyAssignItems > 0" class="infoAssignItem p-3 mt-2 rounded">
        <v-chip
          v-for="assignItem in assignItems"
          :key="`${mode}-${assignItem.pk}`"
          class="mr-2"
          color="secondary"
          pill
          @click.stop="open()"
        >
          <v-avatar left>
            <i-image
              :value="assignItem.suborder.photo"
              :preview="true"
              :readonly="true"
            />
          </v-avatar>
          {{ assignItem.suborder.name }}
          <v-chip color="primary" class="ml-1" small>
            {{ $t(assignItem.status) }}
          </v-chip>
        </v-chip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DialAssignDriver from '@/components/sale/dialAssignItem.vue'
export default {
  components: {
    DialAssignDriver
  },
  props: {
    selectedItem: {
      required: true,
      type: [String, Number]
    },
    mode: {
      default: 'driver',
      type: [String]
    },
    template: {
      type: Number
    }
  },
  data() {
    return {
      assignItems: [],
      avalaible: 0,
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = this.getPermissions([`sales.change_assigneduser`])
      this.$refs.dialassignitem.open()
    },
    getAssignItems() {
      this.$api.suborder.assigneduser
        .show({
          pk: this.selectedItem,
          opt: {
            params: {
              mode: this.mode
            }
          }
        })
        .then((response) => {
          this.assignItems = response.data
        })
    },
    /**
     * Método que selecciona la traducción adecuada según el modo que se le pase
     * como parámetro
     * @param {string} mode - Cadena que determina si es diseñador, productor o
     *                        conductor.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    getTranslateMode(mode) {
      const LOCALES_MODE = {
        designer: 'designer',
        production: 'productions',
        delivery: 'driver'
      }

      return LOCALES_MODE[mode]
        ? this.$tc(LOCALES_MODE[mode])
        : this.$tc('suborder')
    }
  },
  computed: {
    qtyAssignItems() {
      return this.assignItems.length
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions'
    })
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAssignItems()
        }
      }
    }
  }
}
</script>
<style lang="sass">
.infoAssignItem
  background-color: rgb(200 200 200 / .3)
  display: flex
  flex-direction: column
  align-items: baseline
  flex-wrap: wrap
  gap: 8px
.theme--dark
  .infoAssignItem
    background-color: rgb(0 0 0 / .25)
</style>
